import { render } from "./CharlasSection.vue?vue&type=template&id=6987e6a3&scoped=true&ts=true"
import script from "./CharlasSection.vue?vue&type=script&lang=ts"
export * from "./CharlasSection.vue?vue&type=script&lang=ts"

import "./CharlasSection.vue?vue&type=style&index=0&id=6987e6a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6987e6a3"]])

export default __exports__